import { EvseType } from './types';

export type EvseVariant = 'Hardwired' | 'NEMA_14_50' | 'Unknown';

export type DetectedEvseModel = { modelNumber: string | null; evseVariant: EvseVariant };

// The connector suffix (J1772 / J3400) is shared by both variants, so only the prefix identifies the variant.
const MODEL_PREFIX_LENGTH = 8;

const MODEL_PREFIX_TO_VARIANT = new Map<string, Exclude<EvseVariant, 'Unknown'>>([
  ['EVRBA48A', 'Hardwired'],
  ['EVRBA40A', 'NEMA_14_50'],
  ['YOSEMITE', 'Hardwired'],
  ['NEMA', 'NEMA_14_50'],
]);

export function resolveEvseVariant(model: string | null | undefined): EvseVariant {
  const prefix = model?.trim().toUpperCase().slice(0, MODEL_PREFIX_LENGTH) ?? '';
  return MODEL_PREFIX_TO_VARIANT.get(prefix) ?? 'Unknown';
}

export function getEvseTypeForVariant(variant: EvseVariant): EvseType | null {
  if (variant === 'Hardwired') return 'SmartAmp';
  if (variant === 'NEMA_14_50') return 'SmartPlug';
  return null;
}
